module.exports = __webpack_public_path__ + "img/00673682000101.55580f56.png";